import React, { Component } from 'react';
import {setLoadingSequence} from 'actions/index.js';
import accounts from 'accounts/Accounts.js';
import { connect } from "react-redux";
import {setShowShareSequenceModal} from 'actions/index.js';
import SequenceListComponent from 'components/sequences/SequenceListComponent.js';
import ShareSequenceModal from 'components/modals/ShareSequenceModal.js';
import GetSequences from 'search/GetSequences.js';
import Web3 from 'web3';
import ethereum from 'decentralized/ethereum.js';
import '../../Palette.css';
import {InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

const FILTER_BY_USER = 'FILTER_BY_USER';
const NO_FILTER_BY_USER = 'NO_FILTER_BY_USER';
const PAGE_SIZE = 12;
const metamaskInstalled = false;
const web3 = metamaskInstalled ? new Web3(window.web3.currentProvider) :
      new Web3(new Web3.providers.HttpProvider('https://ropsten.infura.io/v3/2f3dce2af1044e88b4851c3d73c3d00c'));

class SequencesComponent extends Component {
    constructor(props) {
        super(props);

        this.getCounter = 0;

        this.state = {
            searchTerms: '',
            userToFilter: undefined,
            sequences: [],
            filteredSequences: [],
            sequencesToDisplay: [],
            rawSequences: [],
            start: 0,
            total: 0,
            showingEdits: false,
            user: undefined,
            filterByUser: props.filterByUser === undefined ? true : this.props.filterByUser,
        };
        // show sequences
        this.getSequences();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.guildId !== this.props.guildId) {
            console.log('guild changed to=' + nextProps.guildId);
            this.getSequences(nextProps.guildId);
        }
        return true;
    }

    showEdits(x) {
        if (x) {
            return;
        }
        this.state.sequences = this.convertSequences(
            ethereum.collapseAllSequences(this.state.rawSequences));
        this.setState({
            showingEdits: false,
            sequencesToDisplay: this.getSequencesToDisplay()});
    }

    filterSequencesByUser(user) {
        this.state.userToFilter = user;
        this.state.start = 0
        this.state.searchTerms = '';
        if (user === undefined) {
            this.setState({
                userNameToFilter: undefined,
                sequencesToDisplay: this.getSequencesToDisplay()});
            return;
        }
        this.getUserName(user);
        this.setState({
            sequencesToDisplay: this.getSequencesToDisplay()
        });
    }

    async onClickEdits(sequenceId) {
        this.getCounter++;
        let sequences = await this.getEditsForSequence(sequenceId);
        this.setState({
            showingEdits: true,
            sequences : this.convertSequences(sequences),
        });

        this.state.sequences = this.convertSequences(sequences);
        this.state.searchTerms = '';
        
        this.setState({
            sequencesToDisplay: this.getSequencesToDisplay()
        });
 
    }

    async onSearchTermsChanged(event) {
        this.state.start = 0;
        this.state.searchTerms = event.target.value;
        this.setState({
            sequencesToDisplay: this.getSequencesToDisplay()
        });
    }

    convertSequences(ret) {
        return ret
            .filter(r => r.title !== undefined)
            .map(r => {
            return {... r, name: r.title, id: r.newSequence, user: r.user, blockNumber: r.blockNumber, edits: r.edits};
        });
    }

    async getSequences(guildId=this.props.guildId) {
        this.getCounter++;
        if (guildId !== 0) {
            let sequences = await ethereum.guildSequences
                .getGuildSequences(guildId);
            this.handleGetSequencesResults(sequences);
            console.log('sequences = ');
            console.log(sequences);
        } else {
            let counter = this.getCounter;
            let user = undefined;
            if (this.state.filterByUser) {
                user = await accounts.getAccount();
            }
            
            let getSequences = new GetSequences(ethereum);
            await getSequences.executeQuery(user);
            let sequences = [];
            while (sequences !== undefined) {
                sequences = await getSequences.getNext();
                if (this.getCounter !== counter) {
                    return;
                }
                this.handleGetSequencesResults(getSequences.results);
            }
        }
    }

    async handleGetSequencesResults(ret) {
        this.setState({rawSequences: ret});
        ret = ethereum.collapseAllSequences(ret);
        let sequences = this.convertSequences(ret);
        
        this.setState({
            sequences : sequences,
        });
        
        this.setState({
            sequencesToDisplay: this.getSequencesToDisplay()
        });
    }

    onChooseSequence(id, sequence) {
        if (this.props.onLoad === undefined) {
            this.props.setLoadingSequence(id, true);
            this.props.sequencerEngine.loadSequence(id);
        } else {
            this.props.onLoad(sequence);
        }
    }

    getSequencesToDisplay() {
        if (this.state.sequences.length == 0) {
            return [];
        }

        let sequences = this.state.sequences;
        if (this.state.searchTerms !== '' && this.state.userToFilter === undefined) {
            sequences = this.convertSequences(this.state.rawSequences).filter(
                sequence => sequence.name.toLowerCase().includes(this.state.searchTerms.toLowerCase()));
        } else if (this.state.userToFilter !== undefined && this.state.searchTerms === '') {
            sequences = this.convertSequences(this.state.rawSequences)
                .filter(s => s.user === this.state.userToFilter);
        }

        this.setState({total: sequences.length});

        if (sequences.length > this.state.start + PAGE_SIZE) {
            let s = sequences.slice(this.state.start, this.state.start + PAGE_SIZE);
            return s;
        }

        return sequences.slice(this.state.start);
    }

    async addDates(list) {
        let l = [];
        for (let i in list) {
            let element = list[i];
            let block = await web3.eth.getBlock(element.blockNumber);
            l.push({name: element.name,
                    id: element.id,
                    user: element.user,
                    date: new Date(block.timestamp * 1000)});
        }

        return l;
    }

    async onClickPrevious() {
        let start = 0;
        if (this.state.start >= PAGE_SIZE) {
            start = this.state.start - PAGE_SIZE;
        }

        this.setState({start: start});
        this.state.start = start;

        this.setState({sequencesToDisplay: await this.getSequencesToDisplay()});
    }

    async onClickNext() {
        let start = this.state.start + PAGE_SIZE;
        this.state.start = start;
        this.setState({sequencesToDisplay: await this.getSequencesToDisplay()});
    }

    async getUserName(user) {
        let name = await ethereum.users.getUserName(user)
        name = name === '' ? user : name;
        this.setState({userNameToFilter: name});
    }

    async getEditsForSequence(id) {
        return await ethereum.getEditsForSequence(id, this.state.rawSequences);
    }

    shareSequence(sequence) {
        // show the share sequence modal
        this.props.setShowShareSequenceModal(sequence);
    }

    onFilterByUserChanged(e) {
        this.state.start = 0;
        this.state.filterByUser = e.target.value === FILTER_BY_USER;
        this.setState(this.state);
        this.getSequences();
    }

    render() {
        return (
            <div className="palette-container">
              <ShareSequenceModal
                show={this.props.showShareModal}
                ethereum={ethereum}
                sequence={this.props.showShareModal}
                />
                <InputGroup className="selector-search">
                  <Input onChange={(event) => this.onSearchTermsChanged(event)} 
                    value={this.state.searchTerms}
                    placeholder="Search sequences" id="search-input"/>
                </InputGroup>
                {this.state.showingEdits ?
                    <div
                          onClick={() => this.showEdits(false)}
                      className="common-button pink-button">BACK</div> : ''}
                    {this.state.userNameToFilter ?
                        <div
                          onClick={() => this.filterSequencesByUser(undefined)}
                          className="filtering-sequences-info">Clear filtering by user {this.state.userNameToFilter} </div> : ''}
              <div>
                  <form>
                    <div className="sequences radio">
                      <label>
                        <input className="sequences filter-radio"
                               type="radio"
                               value={FILTER_BY_USER}
                               checked={this.state.filterByUser}
                               onChange={(e) => this.onFilterByUserChanged(e)} />
                          My Sequences
                      </label>
                      <label>
                        <input className="sequences filter-radio"
                               type="radio"
                               value={NO_FILTER_BY_USER}
                               checked={!this.state.filterByUser}
                               onChange={(e) => this.onFilterByUserChanged(e)} />
                          All
                      </label>
                    </div>
                  </form>
              </div>
              <div className="pagination-pane">
                {this.state.start > 0 ?
                  <div className="field-pagination-button" onClick={() => this.onClickPrevious()}>PREVIOUS</div>
                  : ''}
                {this.state.start + PAGE_SIZE <= this.state.total ? 
                  <div className="field-pagination-button" onClick={() => this.onClickNext()}>NEXT</div>
                  : ''}
                <div className="field-pagination-button">{this.state.start} - {this.state.start + PAGE_SIZE} of {this.state.total}</div>
              </div>
              {this.state.sequencesToDisplay.map(
                  (sequence, i) =>
                      <SequenceListComponent 
                            odd={i % 2 === 1}
                            showingEdits={this.state.showingEdits}
                            getEditsForSequence={(s) => this.getEditsForSequence(s.id)}
                            onClickName={(user) => this.filterSequenceseByUser(user)}
                            ethereum={ethereum}
                            key={"sequence-" + i}
                            onClickEdits={() => this.onClickEdits(sequence.id)}
                            shareSequence={() => this.shareSequence(sequence)}
                            onClick={() => this.onChooseSequence(sequence.id, sequence)}
                            sequence={sequence}/>)
              }
                                                             
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        showShareModal : state.modals.showShareSequenceModal,
        guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0,
    }
};
 
const mapDispatchToProps = dispatch => {
    return {
        setLoadingSequence: (id, loading) => dispatch(setLoadingSequence(id, loading)),
        setShowShareSequenceModal: (show) => dispatch(setShowShareSequenceModal(show)),
    };
};
 

export default connect(mapStateToProps, mapDispatchToProps)(SequencesComponent);

